import axios from 'axios';
import {
  clearCustomerAuth,
  getCustomerRefreshToken,
  getCustomerToken,
  setCustomerTokens,
} from '../utils/customerSession';

const { REACT_APP_API_URL } = process.env;

function isCustomerAuthUrl(url = '') {
  return (
    url.includes('/customer/refresh') ||
    url.includes('/customer/authenticate') ||
    url.includes('/customer/authenticate-otp') ||
    url.includes('/customer/send-otp') ||
    url.includes('/customer/register') ||
    url.includes('/customer/forget-password') ||
    url.includes('/customer/stayjade/')
  );
}

axios.interceptors.request.use((config) => {
  const token = getCustomerToken();
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshPromise = null;

async function refreshAccessToken() {
  const refreshToken = getCustomerRefreshToken();
  if (!refreshToken || !REACT_APP_API_URL) return null;

  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${REACT_APP_API_URL}/customer/refresh`, { refreshToken })
      .then((res) => {
        const { accessToken, token, refreshToken: nextRefresh } = res.data.data || {};
        const nextAccess = accessToken || token;
        setCustomerTokens(nextAccess, nextRefresh);
        return nextAccess;
      })
      .catch(() => {
        clearCustomerAuth();
        return null;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

axios.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error.config;
    const url = config?.url || '';

    if (error.response?.status === 401 && config && !config._retried && !isCustomerAuthUrl(url)) {
      config._retried = true;
      const newAccessToken = await refreshAccessToken();
      if (newAccessToken) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${newAccessToken}`;
        return axios(config);
      }
    }

    return Promise.reject(error);
  }
);
